import React from 'react';

const HeartIcon: React.FC = () => (
  <svg
    fill="none"
    height="1em"
    viewBox="0 0 22 21"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M2.10648 2.32567C3.19719 1.10754 4.62186 0.500031 6.0578 0.500031C7.51661 0.500031 8.937 1.10604 10.0498 2.29101L10.0588 2.30065L11.0276 3.38874L11.9907 2.32577C11.9911 2.32536 11.9915 2.32494 11.9919 2.32453C14.1627 -0.099942 17.7232 -0.0995277 19.8936 2.32577C22.0354 4.71922 22.0354 8.55816 19.8936 10.9516L19.8927 10.9526C18.5057 12.4943 17.1187 14.0425 15.7313 15.5912L15.7303 15.5924L15.7287 15.5941C14.3725 17.1079 13.0159 18.6223 11.6592 20.1306L11.657 20.1675L11.4946 20.3059C11.2074 20.5506 10.7053 20.6061 10.3969 20.22L2.10639 10.9516C2.10636 10.9516 2.10641 10.9516 2.10639 10.9516C-0.0354196 8.55815 -0.0353736 4.71909 2.10648 2.32567ZM2.85148 2.99274C1.04945 5.00654 1.04948 8.27099 2.85157 10.2847L10.9883 19.3812C12.3199 17.9004 13.6517 16.4139 14.9838 14.9269L14.9854 14.9251C16.3729 13.3764 17.761 11.8269 19.1489 10.2841C20.9505 8.27028 20.9503 5.00621 19.1484 2.99263C17.3751 1.0111 14.5092 1.0111 12.7359 2.99263L12.7339 2.99494L11.0211 4.88515L9.3164 2.97086C8.3849 1.9813 7.22647 1.50003 6.0578 1.50003C4.91313 1.50003 3.7571 1.98139 2.85148 2.99274Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export { HeartIcon };
